import { render, staticRenderFns } from "./SectionProductCategory.vue?vue&type=template&id=6fef4978&scoped=true&"
import script from "./SectionProductCategory.vue?vue&type=script&lang=js&"
export * from "./SectionProductCategory.vue?vue&type=script&lang=js&"
import style0 from "./SectionProductCategory.vue?vue&type=style&index=0&id=6fef4978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef4978",
  null
  
)

export default component.exports